import {gql} from '@apollo/client';
import {useMutation} from '@apollo/client/react';

const UPDATE_USER_MUTATION = gql`
    mutation MyMutation($consultantProfileUuid: ID!, $consultantUuid: ID!) {
        updateUser(
            updatedUser: {
                consultantProfileUuid: $consultantProfileUuid,
                uuid: $consultantUuid
            }
        ) {
            consultantProfile {
                name
                uuid
            }
        }
    }
`;

export const useUpdateConsultantProfile = () => {

    const [mutateConsultantProfile, { loading, error, data }] = useMutation(UPDATE_USER_MUTATION);

    const setConsultantProfile = (consultantUuid, consultantProfileUuid) => {
        return mutateConsultantProfile({
            variables: {
                consultantProfileUuid,
                consultantUuid,
            },
        });
    };

    return { setConsultantProfile, loading, error, data };
};
